export default __webpack_public_path__ + "static/media/rat.29d12b9b.png";